import { object, string } from 'yup'
import { translate } from '$i18n/i18n'

export type Catalog = {
	id: string
	text: string
}

export const catalogSchema = object({
	id: string().required(translate('de', 'UI.validation.catalog.id.required'))
})
